export const ORGANIZATION_MODULE_URL = 'organization';
export const ORGANIZATION_ORG_ADMIN_MODULE_URL = 'org-admin/organization';
